module.exports = __webpack_public_path__ + "static/media/ic_stop.f34c7984.svg";